export const REQUEST_TEMPLATE_CREATE = 'REQUEST_TEMPLATE_CREATE'
export const SUCCESS_TEMPLATE_CREATE = 'SUCCESS_TEMPLATE_CREATE'
export const FAILURE_TEMPLATE_CREATE = 'FAILURE_TEMPLATE_CREATE'

export const REQUEST_TEMPLATE_FETCH = 'REQUEST_TEMPLATE_FETCH'
export const SUCCESS_TEMPLATE_FETCH = 'SUCCESS_TEMPLATE_FETCH'
export const FAILURE_TEMPLATE_FETCH = 'FAILURE_TEMPLATE_FETCH'

export const REQUEST_TEMPLATE_DESTROY = 'REQUEST_TEMPLATE_DESTROY'
export const SUCCESS_TEMPLATE_DESTROY = 'SUCCESS_TEMPLATE_DESTROY'
export const FAILURE_TEMPLATE_DESTROY = 'FAILURE_TEMPLATE_DESTROY'

export const SELECT_TEMPLATE = 'SELECT_TEMPLATE'
